module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/sp/index/img_knowledge-89dd950549e26e8aabb15ee088f899c1.png";